import React, { useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import { Pagination, Stack } from '@mui/material';
import useProductListing from '../hooks/useProductListing';

// This page used to filter on the category slug `surgical`, which does not exist
// in the catalogue — the store has 16 product categories and none is `surgical`.
// So it rendered "No products found!" for an unknown length of time: the old code
// fetched all 2,279 products and filtered them down to zero, which produces an
// empty grid rather than an error, indistinguishable from an empty category.
//
// Repointed at `healthcare-devices` (18 products) as confirmed by the store
// owner. The hook reports an unmatched slug separately now, so if this category
// is ever renamed the page says "not set up yet" instead of silently emptying.
const CATEGORY_SLUGS = ['healthcare-devices'];

function Surgical({ isAuthenticated, onAddToCart }) {
  const navigate = useNavigate();

  const {
    products,
    loading,
    error,
    missingCategories,
    currentPage,
    totalPages,
    setPage,
  } = useProductListing({ categorySlugs: CATEGORY_SLUGS, perPage: 30 });

  // Admins belong on the dashboard, not the storefront. This check existed
  // twice, byte-for-byte identical, back to back.
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data')) || {};
    if (userData.isSuperAdmin) navigate('/dashboard');
  }, [navigate]);

  if (loading) return <Loader />;

  return (
    <div className="content-wrapper">
      <section className="multivetamins">
        <h3 style={{ fontSize: '22px', textAlign: 'center', margin: '3% 0' }}>
          {'Surgical'.toLocaleUpperCase()}
        </h3>
        <section className="char-products-section" style={{ margin: '0 0 20px' }}>
          <div className="small-container d-grid">
            {products.length > 0 ? (
              products.map(item => (
                <ProductCard
                  isAuthenticated={isAuthenticated}
                  onAddToCart={onAddToCart}
                  key={item.id}
                  product={item}
                />
              ))
            ) : (
              <p>
                {error
                  ? error
                  : missingCategories.length > 0
                    // Say which thing is misconfigured instead of implying the
                    // shelf is empty.
                    ? 'This section is not set up yet. Please check back soon.'
                    : 'No products found!'}
              </p>
            )}
          </div>
          {totalPages > 1 && (
            <Stack spacing={2} style={{ margin: '5% auto 0', display: 'flex', alignItems: 'center' }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => setPage(value)}
                color="primary"
              />
            </Stack>
          )}
        </section>
      </section>
    </div>
  );
}

export default Surgical;
